import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { inactivateUser } from 'src/services';
import { ModalPortal } from '../shared/Modals/ModalPortal';
import { ProfileDeletionModal } from '../shared/Modals/ProfileDeletionModal';

const clientReasonOptions = [
  `Je n'ai pas trouvé de consultant`,
  `L'utilisation est compliquée`,
  `Je ne suis plus en charge des projets`,
];

const consultantReasonOptions = [
  `Je n'ai pas trouvé de mission`,
  `L'utilisation est compliquée`,
  `Je ne suis plus indépendant`,
];

const ProfileDeletion: React.SFC<IGlobalContextProps & RouteComponentProps> = ({
  context,
  history,
}) => {
  const [state, setState] = React.useState({
    otherReason: '',
    reasonOption: '',
    validationModalIsOpen: false,
  });

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      ...state,
      [(e.target as any).name]: (e.target as any).value,
    });
  };

  const toggleValidationModal = () =>
    setState({
      ...state,
      validationModalIsOpen: !state.validationModalIsOpen,
    });

  const handleSave = async () => {
    const { updateUser } = context;
    const reason = state.otherReason || state.reasonOption;
    if (reason) {
      const deletedUser = await inactivateUser({
        reason,
      });
      if (deletedUser) {
        updateUser(true);
        history.push('/?deletedConfirmation=true');
      }
    }
  };
  const reasonOptions =
    context.user && context.user.type === 'client'
      ? clientReasonOptions
      : consultantReasonOptions;

  return (
    <>
      <Form className='p-5'>
        <Row>
          <Col md='12'>
            <span className='text-dark' style={{ fontSize: '32px' }}>
              Supprimer mon compte
            </span>
            <p className='mt-3'>
              Oups... Dommage !
              <br />
              Pourquoi voulez-vous partir ?
            </p>
          </Col>
        </Row>
        <Row className='d-flex justify-content-between mt-2'>
          <Col md='5' xs='auto'>
            {reasonOptions.map((option: string, key: number) => (
              <FormGroup key={key} style={{ height: '30px' }}>
                <Input
                  type='radio'
                  name='reasonOption'
                  value={option}
                  onChange={handleChange}
                />
                <Label
                  className='mt-1 ml-1'
                  check={option === state.reasonOption}
                >
                  {option}
                </Label>
              </FormGroup>
            ))}
            <FormGroup style={{ height: '30px' }}>
              <Input
                type='radio'
                name='reasonOption'
                value='Autre'
                onChange={handleChange}
              />
              <Label
                className='mt-1 ml-1'
                check={'Autre' === state.reasonOption}
              >
                Autre
              </Label>
            </FormGroup>
            <FormGroup>
              <Input
                type='text'
                name='otherReason'
                disabled={state.reasonOption !== 'Autre'}
                value={state.otherReason}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col md='3'>
            <Button
              className='text-uppercase text-white bg-secondary border-0'
              onClick={toggleValidationModal}
            >
              Valider
            </Button>
          </Col>
        </Row>
      </Form>
      <ModalPortal>
        <ProfileDeletionModal
          isOpen={state.validationModalIsOpen}
          handleSave={handleSave}
          toggleValidationModal={toggleValidationModal}
        />
      </ModalPortal>
    </>
  );
};

export const ProfileDeletionWithGlobalContext = withGlobalContext(
  withRouter(ProfileDeletion)
);



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileDeletion.tsx